// eslint-disable-next-line import/no-anonymous-default-export
export default {
    "title": "ADOR",
    "welcome": "Tervetuloa",
    "target_group": "Kohderyhmä",
    "administration": "Hallinto",
    "housing_companies": "Taloyhtiöt",
    "import": "Tuonti",
    "generate_analysis": "Luo analyysi",
    "search": "Hae",
    "select": "Valitse",
    "items": "Nimikkeet",
    "page": "sivu",
    "ok": "OK",
    "reset": "Tyhjennä",
    "submit": "Lähetä",
    "english": "Englanti",
    "finnish": "Suomi",
    "language": "Kieli",
    "logout": "Kirjaudu ulos",
    "total": "yhteensä",
    "priority": "Prioriteetti",
    "city": "Kaupunki",
    "name_of_loan": "Lainan nimi",
    "loan_number": "Lainan numero",
    "tender_details": "Tarjouksen yksityiskohdat",
    "tender_request_submitted": "Tarjouspyyntö lähetetty",
    "sent_to_email": "Lähetetty sähköpostiin",
    "offer_received": "Tarjous vastaanotettu",
    "offer_valid_until": "Tarjouksen voimassaolo",
    "do_you_want_to_send_tender_request": "Haluatko lähettää tarjouspyynnön?",
    "do_you_want_to_chane_deadline": "Haluatko muuttaa määräaikaa?",
    'deadline_for_quotation_changed_successfully':'Tarjouksen määräaikaa muutettu onnistuneesti',
    "change_deadline": "Päivitä takaraja",
    'internal_quotaion_deadline':'sisäinen Tarjouspyynnön määräpäivä',
    "type_of_loan": "Lainan tyyppi",
    "name_of_the_loan": "Lainan nimi",
    "current_bank_of_the_loan": "Nykyinen pankki",
    "financial_analysis": "Talousanalyysi",
    "shareholder_analysis": "Osakeanalyysi",
    "ltv_analysis": "LTV analyysi",
    "company_information": "Perustiedot",
    "pts": "KPTS",
    "loan_comparison": "Lainavertailu",
    "company": "Yhtiö",
    "buildingtype": "Talotyyppi",
    "landownership": "Tontin omistus",
    "yearofintroduction": "Rakennusvuosi",
    "numberofbuildings": "Rakennusten lkm",
    "numberoffloors": "Kerrosten lkm",
    "apartments": "Asunnot lkm",
    "commercialapartments": "Liikehuoneistot",
    "otherpremises": "Muut tilat",
    "building_type": "Talotyyppi",
    "land_ownership": "Tontin omistus",
    "year_of_introduction": "Rakennusvuosi",
    "number_of_buildings": "Rakennusten lkm",
    "number_of_floors": "Kerrosten lkm",
    "commercial_apartments": "Liikehuoneistot",
    "other_premises": "Muut tilat lkm",
    "address": "Osoite",
    "lender": "Lainanantaja",
    "remaining_capital": "Pääoma",
    "remaining_loan_period": "Laina-aikaa jäljellä",
    "margin": "Marginaali",
    "reference_interest_rate": "Viitekorko",
    "shortening_style": "Lyhennystapa",
    "years": "vuotta",
    "competitive_loan": "Kohteen lainat",
    "housing_company": "Taloyhtiö",
    "hc": "Yhtiö",
    "num_of_shareholders_share_10": "Omistukset osakkeista > 10% lkm",
    "peoplewho_own_more_than_1_apartment": "Henkilöomistajat, > 1 huoneisto",
    "%_of_share": "% osuus",
    "of_share": "% osuus",
    "number_of_share_holder": "Osakkaat lkm",
    "number_of_appartment": "Asunnot lkm",
    "number_of_apartments": "Asunnot lkm",
    "apartments_incl_business_spaces": "Asunnot (sis. liikehuoneistot)",
    "person_owned_and_lives_in": "Henkilöomistuksessa - asuu huoneistossa",
    "person_owned_and_non_lives_in": "Henkilöoimistuksessa - asuu muualla",
    "company_owned": "Yritysomistuksessa",
    "percent_of_total_shares": "Omistusosuus",
    "of_total_shares": "Omistus yhtiön osakkeista",
    "percent_of_total_m2": "Omistus yhtiön m2",
    "of_total_m2": "Omistus yhtiön m2",
    "num_of_apartments": "Asunnot lkm",
    "business_space_m2": "Liikehuoneistot m2",
    "apartment_m2": "Asunnot m2",
    "number_of_car_spaces": "Autopaikat lkm",
    "number_of_other_spaces": "Muut tilat lkm",
    "car_spaces": "Autopaikat",
    "person_owned": "Henkilöomistus",
    "list_of_all_shareholder": "Osakasluettelo",
    "apartment_name": "Huoneisto",
    "shareholder_name": "Osakkaan nimi",
    "home_address_of_shareholder": "Osakkaan kotiosoite",
    "total_share_of_that_shareholder": "Osakkeet yht.",
    "square_meter": "m2",
    "ownership_percentage": "m2 yht.",
    "business_id": "y-tunnus",
    "people_who_own_more_than_one_apartment": "Henkilöomistaja, > 1 huoneisto omistuksessa",
    "num_of_appartment_they_own_in_this_hc": "Huoneisto lkm",
    "how_many_shares_they_own": "Huoneistojen osakkeet",
    "the_percentage_of_the_shares_owned_of_hc": "Osuus osakkeista",
    "company_shareholder": "Yritysosakkaat",
    "shareholders_people_who_own_more_than_10%_shares": "Henkilöomistajat, > 10% osakkeiden omistuksesta",
    "shareholders_people_who_own_more_than_10_shares": "Henkilöomistajat, > 10% osakkeiden omistuksesta",
    "year_of_construction": "Rakennusvuosi",
    "propertytype": "Kiinteistötyyppi",
    "sales": "Myynti",
    "plot": "Tontti",
    "postalcode": "Postinumero",
    "street": "Katu",
    "hspsoldapartments": "HSP - Myydyt huoneistot",
    "apartmenttype": "Kohdetyyppi",
    "numberofrooms": "Huone lkm",
    "averageeurm2ka": "eur/m2 ka",
    "eurm2_lower_quartile": "eur/m2 (alakvartiili)",
    "eurm2_upper_quartile": "eur/m2 (yläkvartiili)",
    "numberofsoldapartments": "Myydyt asunnot",
    "hspsoldcarspaces": "HSP - Myydyt autopaikat",
    "type": "Tyyppi",
    "averagedebtfreeprice": "Velaton hinta ka",
    "debtfreepricelowerquartile": "Velaton hinta (alakvartiili)",
    "debtfreepriceupperquartile": "Velaton hinta (yläkvartiili)",
    "amountofsoldcarspaces": "Myydyt autopaikat",
    "notable_done_renovations": "Tehdyt korjaukset",
    "notable_upcoming_renovations": "Tulevat korjaukset",
    "renovation_type": "Aihealue",
    "scope": "Laajuus",
    "description": "Kuvaus",
    "starting_year": "Vuosi",
    "data_description": "Tietojen kuvaus",
    "status": "Tila",
    "actions": "Toimenpide",
    "used_for": "Käyttötarkoitus",
    "last_import_done_date_and_time": "Viimeksi päivitetty",
    "click_or_drag_file_to_this_area_to_upload": "Napsauta tai vedä tiedosto tälle alueelle ladataksesi sen",
    "support_for_a_single_upload_strictly_prohibit_from_uploading_company_data_or_other_band_files": "Support for a single upload. Strictly prohibit from uploading company data or other band files",
    "account_master": "Account Master",
    "housewise_account_categorization": "tilikategoriat",
    "customer_data": "Asiakasdata",
    "accounting_data": "Hausvise Kirjanpito",
    "osakerekisteri_shareholder_data": "Osakerekisterin tiedot",
    "patrick_dimyhtio": "Patrick dimyhtio",
    "dw_lainarekisteri_loan_data": "Lainadata",
    "hsp_rivitieto_hsp_sales_data": "HSP  rivitieto",
    "start_year_is_required": "Aloitusvuosi vaaditaan",
    "end_year_is_required": "Lopetusvuosi vaaditaan",
    "please_select_property_type": "Ole hyvä ja valitse kiinteistötyyppi",
    "erillistalo": "Erillistalo",
    "kerrostalo": "Kerrostalo",
    "omakotitalo": "Omakotitalo",
    "paritalo": "Paritalo",
    "rivitalo": "Rivitalo",
    "tontti": "Tontti",
    "please_select_land_ownership": "Ole hyvä ja valitse tontin omistus",
    "oma": "Oma",
    "vuokra": "Vuokra",
    "muu": "Muu",
    "last_24_months": "Viimeiset 24 kk",
    "last_12_months": "Viimeiset 12 kk",
    "last_6_months": "Viimeiset 6 kk",
    "kiinteistön_hinta_arvio_perustuu_kiinteistönvälittäjien_hintaseurantapalvelun_tietokantaan_toteutuneista_kaupoista_hinta_arviossa_on_otettu_huomioon_muun_muassa_alueella_myytyjen_kohteiden_todelliset_myyntihinnat_hinta_arvio_ei_välttämättä_vastaa_kiinteistön_todellista_hintaa_vaan_antaa_tietoa_alueen_keskimääräisistä_myyntihinnoista_hinta_arvio_perustuu_tilastoihin_ja_keskiarvoihin_mikä_tarkoittaa_sitä_että_kiinteistön_yksilöllisiä_piirteitä_esim_asuntojen_kunto_ei_oteta_huomioon_tuloksissa": "Kiinteistön hinta-arvio perustuu kiinteistönvälittäjien hintaseurantapalvelun tietokantaan toteutuneista kaupoista. Hinta-arviossa on otettu huomioon muun muassa alueella myytyjen kohteiden todelliset myyntihinnat. Hinta-arvio ei välttämättä vastaa kiinteistön todellista hintaa, vaan antaa tietoa alueen keskimääräisistä myyntihinnoista. Hinta-arvio perustuu tilastoihin ja keskiarvoihin, mikä tarkoittaa sitä, että kiinteistön yksilöllisiä piirteitä (esim. asuntojen kunto) ei oteta huomioon tuloksissa.",
    "postal_code": "Postinumero",
    "kohteen_lainat,_kiinteiston_indikatiivinen_hinta_arvio_ja_ltv": "Kohteen lainat, kiinteiston indikatiivinen hinta-arvio ja LTV",
    "lainan_nimi": "Lainan nimi",
    "paaoma_jaljella": "Paaoma jaljella",
    "indik_hinta_arvio_ka": "Indik hinta-arvio ka",
    "indik_hinta_arvio_alakvartiili": "Indik hinta-arvio alakvartiili",
    "indik_hinta_arvio_ylakvartiili": "Indik hinta-arvio ylakvartiili",
    "ltv": "LTV",
    "ltv_min": "LTV min",
    "ltv_max": "LTV max",
    "apartments_and_indicative_price_estimate_per_apartment_type": "Kohteen huoneistot ja indikatiivinen hinta-arvio per huoneistotyyppi",
    "rooms": "Huone lkm",
    "area": "Pinta-ala",
    "amount_of_apartments": "Huoneisto lkm",
    "average_eurm2": "eur/m2 ka",
    "average_indicative_price_estimate": "Indik. hinta-arvio",
    "indicative_price_estimatelower_quartile": "Indik. hinta-arvio (alakvartiili)",
    "indicative_price_estimateupper_quartile": "Indik. hinta-arvio (yläkvartiili)",
    "kohteen_autopaikat_ja_indikatiivinen_hinta_arvio": "Kohteen autopaikat ja indikatiivinen hinta-arvio",
    "autopaikkojen_lkm_osakkeelliset": "Autopaikkojen lkm (osakkeelliset)",
    "velaton_hinta_ka": "Velaton hinta ka",
    "indik_arvo_ka": "Indik arvo ka",
    "indik_arvo_alakvartiili": "Indik arvo alakvartiili",
    "indik_arvo_ylakvartiili": "Indik arvo ylakvartiili",
    "hsp_sold_apartments": "HSP - Myydyt huoneistot",
    "apartment_type": "Asuntotyyppi",
    "number_of_rooms": "Huone lkm",
    "average_eurm2_ka": "eur/m2 ka",
    "number_of_sold_apartments": "Myydyt asunnot",
    "hsp_sold_car_spaces": "HSP - Myydyt autopaikat",
    "average_debt_free_price": "Velaton hinta ka",
    "debt_free_pricelower_quartile": "Velaton hinta (alakvartiili)",
    "debt_free_priceupper_quartile": "Velaton hinta (yläkvartiili)",
    "amount_of_sold_car_spaces": "Myydyt autopaikat",
    "katu": "Katu",
    "map": "Kartta",
    "file_uploaded_successfully": "Tiedoston lataus onnistui",
    "file_validation_failed": "Tiedoston validointi epäonnistui",
    "file_validated_successfully": "Tiedoston validointi onnistui",
    "customer_id": "Tunnus",
    "customer_name": "Asiakkaan nimi",
    "housing_manager_name": "Isännöitsijän nimi",
    "housing_manager_email": "Isännöitsijän sähköposti",
    "housing_manager_phone": "Isännöitsijän puhelinnumero",
    "number_of_apartment_patdim_data": "Asunto lkm (Patrik DimYhtio)",
    "number_of_apartment_shareholder_data": "Asunto lkm (Osakasrekisteri)",
    "number_of_business_space_patdim": "Liikehuoneisto lkm (Patrik DimYhtio)",
    "number_of_car_space_patdim_data": "Autopaikka lkm (Patrik DimYhtio)",
    "number_of_car_space_shareholder_data": "Autopaikka lkm (Osakasrekisteri)",
    "no_data": "Ei dataa",
    "of": "of",
    "january": "tammikuu",
    "february": "helmikuu",
    "march": "maaliskuu",
    "april": "huhtikuu",
    "may": "toukokuu",
    "june": "kesäkuu",
    "july": "heinäkuu",
    "august": "elokuu",
    "september": "syyskuu",
    "october​": "lokakuuta",
    "november": "marraskuu",
    "december": "joulukuu",
    "generate_pdf": "Lataa PDF",
    "asunto_oy_virontörmänkatu_10": "Asunto Oy Virontörmänkatu 10",
    "analyysi_indikatiivista_tarjousta_varten": "Analyysi indikatiivista tarjousta varten",
    "analysis_for_indicative_loan_offer​": "Analyysi",
    "sisällys​​​": "Sisällys​​​",
    "perustiedot_yhtiöstä_ja_kilpailutettavasta_lainasta": "Perustiedot yhtiöstä ja kilpailutettavasta lainasta",
    "analyysin_yhteenveto​​": "Analyysin yhteenveto​​",
    "markkinahintapohjainen_indikaatio_loan_to_value": "Markkinahintapohjainen indikaatio - Loan to value",
    "taloudellinen_analyysi": "Taloudellinen analyysi",
    "osakeanalyysi": "Osakeanalyysi",
    "basic_information": "Perustiedot",
    "build_year": "Rakennusvuosi",
    "number_of_business_spaces": "Liikehuoneistot lkm",
    "num_of_car_spaces": "Autopaikat lkm",
    "of_which_hc_owned": "Joista yhtiön hallinnassa",
    "housing_manager": "Isännöitsijä",
    "bank": "Tarjoava pankki",
    "current_capital": "Pääoma jäljellä",
    "margin_value": "Marginaali",
    "loaner_group": "Pankki",
    "loan_time_left": "Laina-aikaa jäljellä",
    "loan_time": "Laina-aika (v)",
    "repayment_method": "Lyhennystapa",
    "number_of_yearly_payment": "Lyhennysten määrä/v",
    "housing_company_accountant": "Kirjanpitäjä",
    "yearly_payments": "Lyhennysjakso",
    "last_reference_data_check": "Korko muuttunut pvm",
    "next_reference_data_check": "Tarkistukseen kk käljellä (tarkistus pvm)",
    "interest_rate": "Korko %",
    "name_of_the_bank": "Pankki",
    "loan_time_remaining": "Laina-aikaa jäljellä",
    "reference_rate": "Viitekorko",
    "payment_type": "Lyhennystapa",
    "tendered_loan": "Kilpailutettava laina",
    "kpl": "kpl",
    "ltv_analysis_market_based_indicative_value_estimation": "Markkinapohjainen indikaatio - Loan to value",
    "loans_indicative_value_estimation_of_the_property_and_ltv": "Kohteen lainat, kiinteistön indikatiivinen hinta-arvio ja LTV",
    "loan_name": "Lainan nimi",
    "capital": "Pääomaa jäljellä",
    "estimated_value_average": "Indik. hinta-arvio, ka",
    "estimated_value_lower_quartile": "Indik. hinta-arvio, alakvartiili",
    "estimated_value_upper_quartile": "Indik. hinta-arvio, yläkvartiili",
    "breakdown_of_value_estimation_for_hcs_apartments_business_spaces_and_car_spaces": "Taloyhtiön asuntojen, liiketilojen ja autopaikkojen hinta-arvion erittely",
    "build_year_of_property": "Rakennusvuosi",
    "filtered_build_years": "Rakennusvuodet",
    "property_type": "Talotyyppi",
    "zip": "Postinumero",
    "region": "Alue",
    "sales_period": "Myyntikausi",
    "room_number": "Huone lkm",
    "total_m2_summarized": "Pinta-ala",
    "total_number_of_apartments": "Asunto lkm",
    "em2_average": "e/m2 ka",
    "number_of_sales": "Myynti lkm",
    "estimation_basis": "Arvion peruste",
    "business_spaces": "Liikehuoneistot",
    "total_number_of_business_spaces": "Liikehuoneisto lkm",
    "total_m2": "Kokonaispinta-ala",
    "total_number_of_car_spaces": "Autopaikat lkm",
    "average_price": "Keskihinta",
    "disclaimers": "Huomioita",
    "disclaimer": "Huomioita",
    "last": "Viimeiset",
    "months": "kk",
    "pts_22_–_tehdyt_merkittävät_korjaukset": "KPTS (3/3) – Tehdyt merkittävät korjaukset",
    "pts_12_–_korjaustarpeet": "KPTS (1/3) – Korjaustarpeet",
    "save": "Tallenna",
    "empty": "Tyhjä",
    "osakeanalyysi_12": "Osakeanalyysi (1/2)",
    "osakeanalyysi_22": "Osakeanalyysi (2/2)",
    "x_apartments_and_y_business_spaces_dynamic_text": "X Asunnot and Y Liikehuoneistot",
    "share_of_apartment_shares": "Osuus huoneistojen osakkeista",
    "yksityisomistuksessa—_asuu_huoneistossa_people_owned_lives_in_hc": "Yksityisomistuksessa— asuu huoneistossa",
    "yritysten_omistuksessa_company_owned": "Yritysten omistuksessa",
    "yksityisomistuksessa—_asuu_muualla_people_owned_lives_elsewhere": "Yksityisomistuksessa— asuu muualla",
    "taloudellinen_analyysi​": "Taloudellinen analyysi​",
    "hoitokuluihin_12_kk_rullaava_ka_suhteutettu_maksukyvykkyys_vrt_tavoite_ja_kaikkien_kohteiden_ka": "Hoitokuluihin (12 kk rullaava ka) suhteutettu maksukyvykkyys vrt. tavoite ja kaikkien kohteiden ka",
    "hoitotuotot_hoitokulut_ja_urakkakulut": "Hoitotuotot, hoitokulut ja urakkakulut",
    "autopaikkoja_4_kpl__x_number_of_car_spaces_dynamic_table__text": "Autopaikat X kpl",
    "num_of_spaces": "Tilojen lukumäärä",
    "share_of_car_space_shares": "Osuus autopaikkojen osakkeista",
    "yksityisomistuksessa__people_owned": "Yksityisomistuksessa",
    "yritysten_omistuksessa__company_owned": "Yritysten omistuksessa",
    "henkilöriskit__shareholderrisks_people__both_=10_ownershipsand_multiple_apartments": "Henkilöomistajat, useita huoneistoja tai yli 10 % omistus",
    "yritykset__company_shareholders": "Yritykset ja yhteisöt",
    "share_of_hc_shares": "Osuus yhtiön osakkeista",
    "aloitus": "Aloitus",
    "kunnossapitotarve": "Kunnossapitotarve",
    "toimenpiteen_laajuus": "Toimenpiteen laajuus",
    "tarkka_kuvaus": "Tarkka kuvaus",
    "please_wait": "Odota...",
    "export_pdf": "Vie PDF",
    "updated_successfully": "Lähetetty onnistuneesti",
    "analyysin_yhteenveto": "Analyysin yhteenveto",
    "loan_to_value_indikaatio​": "Loan to value -indikaatio​",
    "maksu_kyvykkyys​": "Maksu-kyvykkyys​",
    "osakkaat": "Osakkaat",
    "ei_huomioitavaa": "Ei huomioitavaa",
    "huomioitavaa​": "Huomioitavaa​",
    "tendering_list_for_moderator": "Tarjoukset",
    "loan_offer_comparison_summary_for_moderator": "Lainavertailu",
    "open_loan_tendering_case": "Avoimet kilpailutukset",
    "ahc": "Yhtiö",
    "loan_id": "Lainan numero",
    "loan_amount_eur": "Lainan määrä €",
    "loan_amount": "Pääoma €",
    "moderator": "Moderaattori",
    "preliminary_potential_savings": "Alustava säästöpotentiaali",
    "retta_earning_potential": "Rettan ansaintapotentiaali",
    "date_of_ahc_board_meeting": "Hallituksen kokouksen päivämäärä",
    "deadline": "Määräpäivä",
    "offers_received": "Tarjouksia vastaanotettu",
    "retta_earning": "Rettan järjestelypalkkio",
    "replaced_by_loan": "Korvattu lainalla",
    "mark_as_invoiced": "Merkitse laskutetuksi",
    "mark": "Merkitse",
    "closed_loan_tendering_case": "Suljetut kilpailutukset",
    "nordea": "Nordea",
    "aktia": "Aktia",
    "danske_bank": "Danske Bank",
    "handelsbanken": "Handelsbanken",
    "hypo": "HYPO",
    "op": "Osuuspankki",
    "s_pankki": "S-Pankki",
    "export": "Vie",
    "loans_indicative_price_estimate_of_the_property_and_ltv": "Kohteen lainat, kiinteistön indikatiivinen hinta-arvio ja LTV",
    "average_indicative_price_lower_quartile": "Indikatiivinen hinta-arvio, alakvartiili",
    "average_indicative_price_upper_quartile": "Indikatiivinen hinta-arvio, yläkvartiili",
    "car_spaces_and_indicative_price_estimate": "Kohteen autopaikat ja indikatiivinen hinta-arvio",
    "amount_of_car_spaces": "Autopaikkojen lkm (osakkeelliset)",
    "average_indicative_value": "Indikatiivinen hinta-arvio, ka",
    "indicative_value_lower_quartile": "Indikatiivinen hinta-arvio, alakvartiili",
    "indicative_value_upper_quartile": "Indikatiivinen hinta-arvio, yläkvartiili",
    "business_spaces_and_indicative_price_estimate": "Kohteen liiketilat ja indikatiivinen hinta-arvio",
    "amount_of_business_spaces": "Liiketilojen lkm",
    "single_loan_tendering_view": "Tarjousnäkymä",
    "quotation_submit_time": "Tarjouspyynnön lähetys pvm",
    "documents": "Dokumentit",
    "quotation_received_and_valid_until": "Tarjous vastaanotettu ja voimassa",
    "payments_per_year": "Lyhennysten määrä / v",
    "interest_base": "Viitekorko",
    "loan_span": "Laina-aika",
    "downpayment_type": "Lyhennystapa",
    "sanction": "Lainan siirron sanktio %",
    "fee": "Järjestelypalkkio",
    "document": "Dokumentti",
    "one_loan_quotation": "Tarjouspyyntö",
    "to_bank": "Pankille",
    "documents_and_date": "Dokumentit ja päivämäärä",
    "winner": "Asiakkaan hyväksymä",
    "feedback": "Palaute",
    "cancel":"Peruuta",
    "select_loan":"Valitse laina",
    "are_you_sure_you_want_to_move_this_loan_to_the_tendering_list":"Haluatko siirtää lainan tajouspyyntölistalle?",
    "tenders":"Tarjouspyynnöt",
    "select_date":"Päivämäärä",
    "please_input_deadline_date":"Lisää määräpäivä",
    "please_input_your_reason":"Lisää syy",
    "yes":"Kyllä",
    "loan_is_already_tendered":"Laina on jo kilpailutettu",
    "reason":"Syy",
    "deadline_date":"Määräpäivä pvm",
    "please_input_dedline_date":"Lisää määräpäivä",
    "email": "Sähköposti",
    "phone": "Puhelin",
    "name": "Nimi",
    "single_loan_view_moderator": "Yhden lainan näkymä",
    "loaner_grouped": "Lainanantaja",
    "sannoitsija": "sannoitsija",
    "notes": "Viesti pankeille",
    "start_tendering": "Aloita kilpailutus",
    "number_of_tenders_received": "Saapuneiden tarjousten määrä",
    "files": "Tiedostot",
    "banks_participating_this_tendering": "Kilpailutukseen osallistuvat pankit",
    "select_all_select_none": "Valitse kaikki / jätä valitsematta",
    "saastopnakki": "Saastopnakki",
    "upload": "Lataa",
    "send": "Lähetä",
    "tender_edited_successfully": "Tarjouksen muokkaaminen onnistui",
    "tender_save_successfully":"Tarjous tallennettu",
    "total_records": "Tietojen määrä",
    "pts_analysis_data":"PTS tiedot",
    "share_holder_analysis":"Osakeanalyysi",
    "perust_hierarkia": "Perust Hierarkia",
    "pts_analysis": "PTS Analysis",
    "sännöitsijä": "Isännöitsijä",
    "Kirjanpitäjä": "Kirjanpitäjä",
    "Moderaattori": "Moderaattori",
    "single_loan_view": "Yhden lainan näkymä",
    "ador_analysis": "Ador-analyysi",
    "shareholder": "Osakasluettelo",
    "allekirjoitettu_tilinpaatos_ja_toimintaketomus": "Allekirjoitettu tilinpäätös ja toimintakertomus",
    "isannoitijantodistu": "Isännöitsijäntodistus",
    "energy_certificate": "Energiatodistus",
    "deadline_for_quotation": "Takaraja - Tarjouksen jättö",
    "margin_percentage": "Marginaali %",
    "payment_method": "Lyhennystapa",
    "reference_rate_base": "Korkosidos",
    "payment_interval_months": "Lyhennysjakso kk",
    "loan_span_years": "Laina-aika",
    "new_capital_amount": "Uusi pääoma €",
    "sanction_for_yearly_payment": "Ennenaikaisen takaisinmaksun palkkio %",
    "arrangement_fee": "Järjestelypalkkio €",
    "transferring_payment_transaction_mandatory": "Maksuliikenteen siirto pakollinen",
    "no": "Ei",
    "valid_until": "Voimassa",
    "attachment": "Liite",
    "choose_file": "Valitse tiedosto..",
    "contact_info": "Yhteystiedot",
    "message": "Viesti",
    "estimated_price_of_mortgage_transfer": "Arvioitu panttikirjojen siirron hinta",
    "additional_attachment": "Muut liitteet",
    "loan_tender_id": "Tarjouspyynnin ID",
    "maksuvalmius": "Maksuvalmius",
    "maksuvalmiuserittely": "Maksuvalmiuserittely",
    "no_of_buildings": "Rakennusten lkm",
    "end_tendering": "Lopeta kilpailutus",
    "message_to_winning_bank": "Viesti asiakkaan valitsemalle pankille",
    "attachments": "Liitteet",
    "end_tendering_select_winner_moderator": "Kilpailutuksen päättäminen",
    "are_you_sure_you_want_to_end_this_tender": "Haluatko varmasti päättää kilpailutuksen?",
    "validate_data": "Validoi tiedot",
    "loan_tendering_costs": "Lainan kilpailutukseen liittyvät kulut",
    "costs_or_savings_related_to_reference_rate_check": "Viitekoron tarkistukseen liittyvät kustannukset tai säästöt",
    "quotaion_deadline": "Tarjouspyynnön määräpäivä",
    "loan_cost_comparison_and_savings": "Lainakustannusvertailu ja säästöt",
    "1_refinancing_costs_covered_with_income_financing": "1. Jälleenrahoituskustannukset rahoitetaan tulorahoituksella",
    "2_refinancing_costs_capitalised": "2. Jälleenrahoituskustannukset pääomitetaan",
    "recommendation": "Suositeltava ratkaisu",
    "other_terms": "Muita ehtoja",
    "loan_transfer_sanction": "Lainan siirron sanktio %",
    "banks_arrangement_fee_€": "Pankin järjestelypalkkio € ",
    "loan_transfer_sanction_€": "Lainan siirron sanktio € ",
    "estimated_price_of_mortage_transfer": "Arvioitu panttikirjojen siirron hinta € ",
    "rettas_fee_vat_24": "Palveluntarjoajan järjestelypalkkio (sis. alv. 0 %)",
    "total_costs": "Marginaalikulut yhteensä",
    "total_costs2": "Kulut yhteensä",
    "current_reference_rate_of_the_loan": "Lainan viitekorko-% tällä hetkellä",
    "time_remaining_to_reference_rate_check_months": "Tarkastukseen kk jäljellä",
    "reference_rate_today": "Euribor tänään",
    "costprofit_of_reference_rate_change_€": "Tappio/säästö Euriborin kiinnittämisestä ",
    "1st_year_savings": "Ensimmäisen vuoden säästö",
    "total_savings": "Nettosäästö yhteensä",
    "total_loan_incl_refinancing_costs": "Uusi pääoma",
    "interest_rate_terms": "Korko minimissään",
    "shareholder_repayments": "Osakaslyhennykset",
    "optional_annual_repayments": "Lyhennysten määrän vaihtoehto (/v)",
    "optional_repayment_method": "Lyhennystavan vaihtoehto",
    "payment_transaction_transfer": "Maksuliikenteen siirto pakollinen",
    "viitekoron_vaihtoehto": "Viitekoron vaihtoehto",
    "moderaattori": "Moderaattori",
    "kirjanpitäjä": "Kirjanpitäjä",
    //manager single view
    "single_loan_view_for_housing_manager": "Lainakilpailutusehdotus",
    "accept": "Hyväksy",
    "reject": "Hylkää",
    "path": "Path",
    "export_loan_comparison": "Siirrä lainavertailu",
    "if_the_refinancing_costs_are_capitalised_general_meeting_decision_is_required": "Mikäli jälleenrahoituskustannukset pääomitetaan, vaaditaan yhtiökokouspäätös",
    "mikäli_järjestelypalkkiot_maksetaan_tulorahoituksella_ja_lainapääoma_pidetään_samana_ei_tarvita_yhtiökokousta_laskennassa_pankin_jälleenrahoituskustannukset_on_jyvitetty_tasaisesti_lyhennysjaksoille_ja_rettan_palkkio_maksetaan_ensimmäisen_vuoden_aikana": "Mikäli järjestelypalkkiot maksetaan tulorahoituksella ja lainapääoma pidetään samana, ei tarvita yhtiökokousta. Laskennassa pankin jälleenrahoituskustannukset on jyvitetty tasaisesti lyhennysjaksoille ja Rettan palkkio maksetaan ensimmäisen vuoden aikana.",
    "print": "Tulosta",
    "view": "Näytä",
    "bank_name": "Pankki",
    "city_id": "Kaupunki ID",
    "city_name": "Kaupunki",
    "contact_name": "Nimi",
    "email_contact": "Sähköposti",
    "phone_number": "Puhelin",   
    "maksuvalmius​":"Maksuvalmius​",
    "kuluihin_12_kk_rullaava_ka_suhteutettu_maksuvalmius": "Kuluihin (12 kk rullaava ka) suhteutettu maksuvalmius",
    "tuotot_ja_kulut": "Tuotot ja kulut",
    "autopaikat_lkm": "Autopaikat lkm",

    /////New keys TBD
    "add_bank_contact_details": "Lisää pankin yhteystiedot",
    "edit_bank_contact_details": "Muokkaa pankin  yhteystiedot",
    "bank_management": "Pankin hallinta",
    "contract": "Contract",
    "send_services_request_to_hm": "Lähetä palvelupyyntö",
    "are_you_sure_you_want_to_send_service_request_to_hm": "Oletko varma, että haluat lähettää palvelupyynnön?",
    "3kk_euribor": "3kk Euribor",
    "6kk_euribor": "6kk Euribor",
    "12kk_euribor": "12kk Euribor",
    "tender_deadline_is_passed": "Kilpailutus on päättynyt",
    "are_you_sure_you_want_to_update_reference_rate" : "Haluatko varmasti päivittää viitekoron?",
    "tender_id": "Kilpailutus-id",
    "asuin__ja_liikehuoneistot_x_kpl": "Asuin- ja liikehuoneistot X kpl",
    "deleted_successfully": "Poistettu onnistuneesti",
    "pdf":"PDF",
    "paikat_lkm": "Paikat lkm",
    "count": "Laske(Source/Target)",
    "select_all": "Valitse kaikki",
    "date_last_refresh": "Viimeisin päivitys pvm",
    "are_you_sure_you_want_to_delete_this_attachment": "Haluatko varmasti poistaa tämän liiteen?",
    "delete": "Poista",
    "are_you_sure_you_want_to_select_this_option": "Are you sure you want to select this option?",
    "no_offer": "Ei tarjousta",
    "are_you_sure_you_want_to_submit":"Oletko varma, että haluat lähettää",
    "current_loan_terms": "Nykyinen laina",
    "offers": "Lainatarjoukset",
    "dont_tender_tendering_cases": "Ei kilpailuteta",
    "revert": "Palauta",
    "edit": "Muokkaa",
    "add_bank": "Lisää pankki",
    "add_bank_name": "Lisää pankki nimi",
    "please_enter_bank_name": "Syötä pankin nimi",
    "completed": "Valmis",
    "not_completed": "Kesken",
    "you_already_have_data_in_this_analysis_do_you_want_to_fresh_upload": "Sinulla on jo dataa analyysissä. Oletko varma, että haluat päivittää?",
    "all": "Kaikki",
    "dont_tender": "Älä kilpailuta",
    "potential": "Potentiaalinen",
    "proposed_for_tendering": "Kilpailutusta tarjottu",
    "tendering_postponed": "Kilpailutetaan myöhemmin",
    "tendering_rejected": "Kilpailutus hylätty",
    "approved_for_tendering": "Kilpailutus hyväksytty",
    "tendering_ongoing": "Kilpailutus käynnissä",
    "tendering_deadline_closing_soon": "Kilpailutus erääntymässä",
    "check_loan_comparison": "Tarkista lainavertailu",
    "comparison_sent": "Vertailu lähetetty",
    "signed_meeting_minutes_received": "Pöytäkirja vastaanotettu",
    "waiting_for_decision": "Odottaa päätöstä",
    "end_tender": "Kilpailutus suljettu",
    "waiting_for_signed_bond": "Odottaa velkakirjaa",
    "bond_sent_to_accounting": "Velkakirja lähetetty kirjanpitoon",
    "invoiced": "Laskutettu",
    "done": "Valmis",
    "tendering_declined": "Tarjous hylätty",
    "requested_for_tendering": "Ehdota kilpailutusta",
    "marketing_materials": "Ador esittelymateriaali",
    "warning":"Huomio",
    "contracts": "Sopimus",
    "upload_contracts": "Lisää sopimus",
    "add_comment": "Lisää kommentti",
    "maximum_500_charecter": "Max 500 merkkiä",
    "file_uploaded_succesfully": "Tiedoston lisäys onnistui",
    "housing_manager_profile": "Isännöitsijän profiili",
    "do_you_want_to_accept_this_tender": "Haluatko hyväksyä kilpailutuspyynnön?",
    "tender_accepted": "Kilpailutus hyväksytty",
    "do_you_want_to_reject_this_tender": "Haluatko hylätä kilpailutuspyynnön?",
    "bank_form": "Tarjouslomake",
    "please_enter_number": "Syötä numero",
    "remove_file": "Poista tiedosto",
    "please_select_payment_method": "Valitse lyhennystapa",
    "please_select_base_rate": "Valitse korkosidos",
    "please_enter_number_between_1_and_12": "Lisää numero 1-12 väliltä",
    "satellite": "Satelliitti",
    "tender_request_successfully_sent": "Tarjouspyyntö lähetetty",
    "download": "Lataa",
    "please_enter_city_name": "Please enter city name",
    "bank_contact_details": "Pankin yhteystiedot",
    "the_input_is_not_valid_email": "Virheellinen sähköpostiosoite",
    "please_enter_phone_number_between_8_to_12_digits": "Virheellinen puhelinnumero",
    "please_enter_contact_name": "Please enter contact name",
    "date": "Päivämäärä",
    "tender_rejected":"Kilpailutus hylätty",
    "please_select_deadline": "Valitse määräpäivä",
    "please_enter_notes": "Syötä muistiinpanot",
    "please_select_status": "Please select status",
    "please_select_bank": "Valitse pankki",
    "are_you_sure_you_want_to_delete_bank_contact_details": "Oletko varma, että haluat poista pankin yhteystiedot ?",
    "bank_contact_updated_successfully": "Pankin yhteystiedot Päivitetty",
    "bank_contact_deleted_successfully": "Pankin yhteystiedot Poistettu",
    "removefile": "Poista tiedosto",
    "please_select_attachment": "Lisää liite",
    "Other": "Muu",
    "please_select_valid_until_date": "Valitse voimassaolopäivä",
    "euribor_rates_daily": "Euriborkorot päivittäin (suomenpankki.fi)",
    "please_attach_document": "liitä dokumentit",
    "other": "Muu",
    "tender_closed_successfully": "Kilpailutus suljettu onnistui",
    "of_hc_shares": "Omistus yhtiön osakkeista",
    "of_hc_m2": "Omistus yhtiön m2",
    "lives_in_hc_elsewhere": "Muualla asuvat osakkaat",
    "m2": "Pinta-ala",
    "files_from_housing_manager": "Tiedostot isännöitsijältä",
    "bank_pdf": "Pankki",
    "apartments_pdf": "Asunnot",
    "service_request_sent_to_hm": "Palvelupyyntö lähetetty",
    "no_response": "Ei vastausta",
    "true": "Kyllä",
    "false": "Ei",
    "are_you_sure_you_want_to_move_this_loan_back_to_the_target_group": "Oletko varma, että haluat palauttaa lainan takaisin kohderyhmään?",
    "no_status": "Ei Tila",
    "export_ador_analysis": "Vie Ador-analyysi",
    "y": "E",
    "n": "K",
    "num_of_apartments_pdf": "Huoneistot lkm",
    "housing_manager_comment": "Isännöitsijän viesti",
    "bank_saved_successfully": "pankki tallennettu onnistuneesti",
    "bank_updated_successfully": "Pankki yhteystiedot Päivitetty",
    "bank_deleted_successfully": "Pankki yhteystiedot Poistettu",
    "mismatch_data": "Ristiriitaisia tietoja löydetty",
    "completed_without_erroneous_records": "Valmis ilman virheellisiä tietoja",
    "file_management": "Tiedoston hallinta",
    "ador_contract": "Ador sopimus",
    "file_description": "Tiedoston Kuvaus",
    "other_spaces": "Muut tilat",
    "next_reference_data_check_ci": "Seuraava tarkistus pvm",
    "edit_new_loan": "Muokkaa uusi laina",
    "create_new_loan": "Lisää uusi laina",
    "loan_invoicing_model": "Laskutusmalli",
    "Recurring":"Jatkuva",
    "Non-Recurring":"Erillisveloitus",
    "Invoicing model updated successfully": "Laskutusmalli päivitetty onnistuneesti",
    "Failed to update invoicing model": "Laskutusmallin päivittäminen epäonnistui",
    "create_loan":"Lisää laina",
    "estimated_amount_of_capital": "Pääoma",
    "reason_for_the_loan": "Lainan tarkoitus",
    "new_loan": "Uusi laina:",
    "please_enter_reason_for_the_loan":"Syötä Lainan tarkoitus",
    "please_enter_estimated_amount_of_capital": "Syötä Pääoma",
    "please_enter_name_of_the_loan": "Syötä Lainan nimi",
    "please_select_housing_company": "Ole hyvä ja valitse Taloyhtiö",
    "sanction_percentage": "Sanktio %",
    "ongoing_renovations": "Käynnissä olevat korjaukset",
    "pts_23_–_kaynnissa_olevat_korjaukset": "KPTS (2/3) – Käynnissä olevat korjaukset",
    "muut_tilat_y_kpl": "muut tilat Y kpl",
    "next_reference_date": "Seuraava koron tarkistuspvm",
    "please_note_that_the_selected_loan_is_a_split_loan": "Huom! Valittu laina on jaettu osiin. Oletko varma, että haluat jatkaa?",
    "loan_time_modified": "Laina-aika, muokattu",
    "are_you_sure_you_want_to_leave_an_offer":"Oletko varma, että et halua jättää tarjousta?",
    "verify_to_your_account": "Vahvista pääsyoikeus",
    "code_is_required": "Turvakoodi vaaditaan",
    "security_code": "Turvakoodi",
    "verify": "Vahvista",
    "invalid_code": "Virheellinen turvakoodi",
    "login_successfully": "Pääsyoikeus vahvistettu",
    "contact_save_successfully": "Yhteystieto lisätty",
    "tendering_notes": "Muistiinpanot",
    "complete": "Valmis",
    "tender_request_already_sent_for_this_loan": "Kilpailutus käynnissä",
    "transformation": "Transformation",
    "data_transformed_successfully": "Data transformed successfully",
    "reset_to_original": "Reset to original",
    "re_tender": "Re-Tender",
    "are_you_sure_you_want_to_re_tender_this_loan":"Are you sure you want to re-tender this loan?",
    "in_active": "In-active",
    "active": "Active",
    "active_Shareholder": "Active Shareholder",
    "in_active_shareholder": "In-active Shareholder",
    "re_activate_shareholder": "Re-activate Shareholder",
    "do_you_want_to_re_activate_the_shareholder_analysis_of_the_housing_company": "Haluatko palauttaa lainan osakeanalyysin aktiiviseksi",
    "data_saved_successfully": "Tietojen tallennettu onnistuneesti",
    "do_you_want_to_disable_the_shareholder_analysis_of_the_housing_company": "Do you want to disable the shareholder analysis of the housing company",
    "disable_shareholder": "Disable Shareholder",
    "update_disable_duration": "Update disable duration",
    "the_input_is_not_valid_email_bank": "Syötä sähköposti",
    "logs": "Logs",
    "purpose_of_the_loan": "Lainan tarkoitus",
    "requested_payment_interval": "Toivottu lyhennysjakso",
    "requested_reference_rate": "Toivottu viitekorko",
    "requested_payment_method": "Toivottu lyhennystapa",
    "please_select_reference_rate" : "Valitse viitekorko",
    "loan_save_successfully" : "Laina tallennettu onnistuneesti",
    "minimum_value_1" : "Vähimmäisarvo 1",
    "maximum_value_12" : "Suurin arvo 12",
    "payment_method_nl": "Toivottu lyhennystapa",
    "reference_rate_base_nl": "Toivottu korkosidos",
    "payment_interval_months_nl": "Toivottu lyhennysjakso kk",
    "maximum_loan_time": "Laina-ajan enimmäisaika",
    "capital_2": "Pääoma",
    "requested_euribor": "Toivottu viitekorko",
    "service_request_is_failed": "Service request is failed",
    "name_of_the_loan_2": "Lainan nimi",
    "enter_numeric_digit_number_less_than_100": "Anna vain numeerinen arvo, joka on pienempi kuin 100",
}